import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Title, Text, Paper, Button, TextInput, Checkbox, Group, Stack, Box } from '@mantine/core';
import { EnvelopeSimple, Rocket, CheckCircle } from '@phosphor-icons/react';
import Logo from '../components/Logo';
import api from '../utils/api';

export default function PreLaunchPage() {
  const [email, setEmail] = useState('');
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/accounts/waiting-list/', { email, accepted_terms: accepted });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Wystąpił błąd. Spróbuj ponownie.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F6F5F4] flex flex-col">
      {/* Header */}
      <div className="py-6 px-6">
        <Logo className="h-10 mx-auto block" />
      </div>

      {/* Main */}
      <div className="flex-1 flex items-center justify-center px-4 pb-16">
        <div className="w-full max-w-md text-center">
          <Title
            order={1}
            mb="sm"
           
            fz={{ base: 32, md: 44 }}
            lh={1.15}
          >
            Startujemy
            <br />
            <span style={{ fontWeight: 900, WebkitTextStroke: '1px currentColor' }}>wkrótce</span>
          </Title>

          <Text c="dimmed" size="lg" mb="xl" maw={400} mx="auto" lh={1.7}>
            Autonomiczny agent do optymalizacji kampanii Google i Meta Ads.
            Zostaw email, a powiadomimy Cię o starcie ze specjalną ofertą.
          </Text>

          {done ? (
            <Paper radius="lg" p="xl" withBorder shadow="sm">
              <Stack align="center" gap="sm">
                <Box style={{ width: 56, height: 56, borderRadius: '50%', background: 'var(--mantine-color-green-0)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <CheckCircle size={28} weight="fill" className="text-green-600" />
                </Box>
                <Title order={3}>Dziękujemy!</Title>
                <Text size="sm" c="dimmed">
                  Twój adres email został zapisany. Powiadomimy Cię o starcie platformy ze specjalną ofertą dla osób z listy oczekujących.
                </Text>
              </Stack>
            </Paper>
          ) : (
            <Paper radius="lg" p="xl" withBorder shadow="sm">
              <form onSubmit={handleSubmit}>
                <Stack gap="md">
                  <TextInput
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="twoj@email.pl"
                    leftSection={<EnvelopeSimple size={18} />}
                    size="lg"
                    required
                  />

                  <Checkbox
                    checked={accepted}
                    onChange={(e) => setAccepted(e.currentTarget.checked)}
                    label={
                      <Text size="xs" c="dimmed">
                        Wyrażam zgodę na przetwarzanie mojego adresu email w celu informowania o starcie i nowościach serwisu Droid.pl.
                        Administratorem danych jest Upcode, ul. Sporna 9, 95-015 Głowno, NIP: 8341813553.
                        Więcej w <Link to="/regulamin-prelaunch" className="underline">regulaminie</Link>.
                      </Text>
                    }
                    color="brand"
                  />

                  {error && <Text size="xs" c="red">{error}</Text>}

                  <Button
                    type="submit"
                    size="lg"
                    radius="md"
                    fullWidth
                    loading={loading}
                    disabled={!email || !accepted}
                    leftSection={<Rocket size={20} weight="fill" />}
                  >
                    Zapisz się na listę
                  </Button>
                </Stack>
              </form>
            </Paper>
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="py-6 text-center">
        <Text size="xs" c="gray.5">
          &copy; 2026 Droid.pl &middot; Upcode, ul. Sporna 9, 95-015 Głowno &middot; kontakt@droid.pl
        </Text>
      </div>
    </div>
  );
}
